import { Subject as RxjsSubject } from 'rxjs';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { PastReportFilter } from '../../../_objects/filter';
import { GeneratedReport, InspectionReport, InspectionReportListItem } from '../../../_objects/inspection-report';
import { Subject } from '../../../_objects/subject';
import { LangUpdateService } from '../../../_services/lang-update.service';
import { InspectionDataManageService } from '../../inspection-data-manage.service';
import { NetworkStatusService } from '../../../_services/network-status.service';

@Component({
    selector: 'app-inspection-report-tab',
    templateUrl: './inspection-report-tab.component.html',
    styleUrls: ['./inspection-report-tab.component.scss'],
    standalone: false
})
export class InspectionReportTabComponent implements OnInit, OnDestroy {
  readonly showExpandCategory = ['Generated Reports', 'Past Reports of Serial'];
  @Input() inspectionReport: InspectionReport;
  @Input() historyReports: InspectionReportListItem[] = [];
  @Input() generatedReports: GeneratedReport[] = [];
  @Input() subjects: Subject[] = [];
  @Input() tooltipPosition: string;
  @Input() height: number;
  @Input() isDeletedInspection: boolean;
  @Input() selectedFilter: string;
  @Input() isReportLoading: boolean;

  selectCategory: string;
  pastReportFilters: PastReportFilter[];
  pastFilterControl: FormControl<PastReportFilter>;

  private onDestroy$ = new RxjsSubject();

  constructor(
    private translate: TranslateService,
    private langService: LangUpdateService,
    private inspDataManageService: InspectionDataManageService,
    private networkStatusService: NetworkStatusService,
  ) {
    this.langService.prepare(translate, this.onDestroy$, (res) => {
      this.showExpandCategory[0] = this.translate.instant('inspectionReportTab.generatedReports');
      this.showExpandCategory[1] = this.translate.instant('inspectionReportTab.pastReports');
      if (this.pastReportFilters) {
        if (this.pastReportFilters[0]) {
          this.pastReportFilters[0].label = this.translate.instant('inspectionReportTab.serial');
        }
        if (this.pastReportFilters[1]) {
          this.pastReportFilters[1].label = this.translate.instant('inspectionReportTab.inspectionTemplate');
        }
        if (this.pastReportFilters[2]) {
          this.pastReportFilters[2].label = this.translate.instant('inspectionReportTab.isOwn');
        }
      }
    });
    if (!this.tooltipPosition) {
      this.tooltipPosition = 'above';
    }
  }

  ngOnInit(): void {
    this.selectCategory = this.showExpandCategory[0];
    this.initpastReportFilters();
    this.initForm();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(undefined);
    this.onDestroy$.unsubscribe();
  }

  public initForm(): void {
    this.pastFilterControl = new FormControl<PastReportFilter>(this.pastReportFilters.find(value => value.column === this.selectedFilter));
  }

  initpastReportFilters(): void {

    this.pastReportFilters = [
      new PastReportFilter('subject', this.translate.instant('inspectionReportTab.serial')),
      new PastReportFilter('subjectModel', this.translate.instant('inspectionReportTab.inspectionTemplate')),
    ];

    if (!this.networkStatusService.isOnPremise) {
      this.pastReportFilters.push(new PastReportFilter('isOwn', this.translate.instant('inspectionReportTab.isOwn')));
    }

  }

  public changePastReportFilter(ev: MouseEvent, filter: PastReportFilter): void {
    this.inspDataManageService.changePastReportFilterEmit(filter.column);
    this.pastFilterControl.setValue(filter);
  }

  public filterText(filter: PastReportFilter): string {
    return filter ? filter.label : '';
  }
}
